import CustomTable from "../../../components/custom-table/custom-table";
import { DraftSubmission } from "../../../data-model/draftSubmission";
import { TableNames } from "../../../enums/tableNames";
import { useCptTableGeneration } from "../hooks/useCptTableGeneration";
import { draftCptTableHeader } from "../utils/draftCptTableDataGenerator";

interface DraftSubmissionCptTableProps {
  draftSubmission?: DraftSubmission;
}

const DraftSubmissionCptTable = (props: DraftSubmissionCptTableProps) => {
  const { cptTableData } = useCptTableGeneration(props.draftSubmission);
  return (
    <div className="draft-submission-cpt-table--container flex flex-col gap-2">
      <div className="draft-submission-cpt-table--header text-sm font-bold">
        CPT Codes
      </div>
      <div className="draft-submission-cpt-table--table">
        <CustomTable
          tableHeaders={draftCptTableHeader}
          tableData={cptTableData}
          tableName={TableNames.DRAFT_SUBMISSION_CPT_TABLE}
          hideSearchBar={true}
          hidePagination={true}
          itemsPerPage={cptTableData.length}
          pagesPerView={3}
          count={cptTableData.length}
        />
      </div>
    </div>
  );
};

export default DraftSubmissionCptTable;
